export default ($stateProvider) => {
  $stateProvider
    .state('wrapper', {
      url: `${location.pathname}?user`,
      abstract: true,
      template: '<nets-wrapper-layout></nets-wrapper-layout>',
    });
};
